export const REG_NUMBER = /^[1-9][0-9]*$/         // 整数(非0开始)


export const REG_DECIMAL   = /^\d+(\.\d*)?$/      // 小数
export const REG_DECIMAL_1 = /^\d+(\.\d{0,1})?$/  // 一位小数
export const REG_DECIMAL_2 = /^\d+(\.\d{0,2})?$/  // 两位小数

// export const REG_DECIMAL_1 = /^[1-9][0-9]*(\.[0-9]{1,1})?$/   // 一位小数
// export const REG_DECIMAL_2 = /^[1-9][0-9]*(\.[0-9]{1,2})?$/   // 两位小数
